<template>
  <div class="main">
    <el-form-item label="Master A/C" prop="merchantNum">
      {{ formData.merchantNum }}
    </el-form-item>
    <!-- <cc-form :config="commonConfig" v-model="tabData" ref="form1" labelWidth="250px" :rules="rules" size="medium"></cc-form> -->
    <el-form-item :label="language('shopInformation.nameEng')" prop="nameEng">
      <el-input v-model="formData.nameEng"></el-input>
    </el-form-item>
    <el-form-item :label="language('shopInformation.nameChi')" prop="nameChi">
      <el-input v-model="formData.nameChi"></el-input>
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.registerArea')"
      prop="registerArea"
    >
      <el-input v-model="formData.registerArea"></el-input>
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.registerNum')"
      prop="registerNum"
    >
      <el-input v-model="formData.registerNum"></el-input>
    </el-form-item>
    <!-- 商業登記證地址 -->
    <h3>{{ language("shopInformation.addressInfo") }}</h3>
    <el-divider></el-divider>
    <el-form-item :label="language('shopInformation.country')" prop="country">
      <el-input v-model="formData.country"></el-input>
    </el-form-item>
    <el-form-item :label="language('shopInformation.region')" prop="region">
      <el-input v-model="formData.region"></el-input>
    </el-form-item>
    <el-form-item :label="language('shopInformation.street')" prop="street">
      <el-input v-model="formData.street"></el-input>
    </el-form-item>
    <el-form-item :label="language('shopInformation.room')" prop="room">
      <el-input v-model="formData.room"></el-input>
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.brCertificateNum')"
      prop="brCertificateNum"
    >
      <el-input v-model="formData.brCertificateNum"></el-input>
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.brCertificateUrl')"
      prop="brCertificateUrl"
    >
      <!-- <el-input v-model="forms.brCertificateUrl"></el-input> -->
      <FormUploader v-model="formData.brCertificateUrl" :formData="formData" />
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.brExpiryDate')"
      prop="brExpiryDate"
    >
      <!-- <el-input v-model="formData.brExpiryDate"></el-input> -->
      <el-date-picker v-model="formData.brExpiryDate" type="date">
      </el-date-picker>
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.introductionUrl')"
      prop="introductionUrl"
    >
      <!-- <el-input v-model="formData.introductionUrl"></el-input>
      < -->
      <FormUploaderFile
        v-model="formData.introductionUrl"
        :formData="formData"
      />
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.businessEmail')"
      prop="businessEmail"
    >
      <el-input v-model="formData.businessEmail"></el-input>
    </el-form-item>

    <h3>{{ language("shopInformation.contact") }}</h3>
    <el-divider></el-divider>
    <el-form-item
      :label="language('shopInformation.contactLastName')"
      prop="contactLastName"
    >
      <el-input v-model="formData.contactLastName"></el-input>
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.contactFirstName')"
      prop="contactFirstName"
    >
      <el-input v-model="formData.contactFirstName"></el-input>
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.contactPosition')"
      prop="contactPosition"
    >
      <el-input v-model="formData.contactPosition"></el-input>
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.contactDepartment')"
      prop="contactDepartment"
    >
      <!-- <el-input v-model="formData.contactDepartment"></el-input> -->
      <FormCheckboxGroup
        v-model="formData.contactDepartment"
        :value="formData.contactDepartment"
      />
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.contactEmail')"
      prop="contactEmail"
    >
      <!-- {{formData.contactEmail}} -->
      <!-- <el-input v-model="formData.contactEmail"></el-input> -->
      <el-select v-model="formData.contactEmail">
        <el-option
          v-for="item in loginEmial"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.contactPersonalPhone')"
      prop="officePhoneNumber"
    >
      <el-input v-model="formData.officePhoneNumber"></el-input>
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.officePhoneNumber')"
    >
      <!-- prop="contactPersonalPhone" -->
      <el-input v-model="formData.contactPersonalPhone"></el-input>
    </el-form-item>
    <el-form-item :label="language('shopInformation.fax')" prop="fax">
      <el-input v-model="formData.fax"></el-input>
    </el-form-item>

    <h3>{{ language("shopInformation.product") }}</h3>
    <el-divider></el-divider>
    <el-form-item :label="language('shopInformation.shopName')" prop="shopName">
      {{ formData.shopName }}
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.shopNameEng')"
      prop="shopNameEng"
    >
      {{ formData.shopNameEng }}
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.productCategory')"
      prop="productCategory"
    >
      <FormDisplayList v-model="formData.productCategory" />
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.productSaleCount')"
      prop="productSaleCount"
    >
      <!-- <el-input v-model="formData.productSaleCount" type="number"></el-input> -->
      <FormProductSaleCount
        v-model="formData.productSaleCount"
      ></FormProductSaleCount>
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.isAgreeHktv')"
      prop="isAgreeHktv"
    >
      <el-radio-group v-model="formData.isAgreeHktv">
        <el-radio :label="1">同意</el-radio>
        <el-radio :label="0">不同意</el-radio>
      </el-radio-group>
    </el-form-item>
  </div>
</template>
<script>
import FormDisplay from "./FormDisplay";
import FormDisplayList from "./FormDisplayList";
import FormUploader from "./FormUploader";
import FormUploaderFile from "./FormUploaderFile";
import FormCheckboxGroup from "./FormCheckboxGroup";
import FormProductSaleCount from "./FormProductSaleCount";

// 设置options

export default {
  model: {
    prop: "formData",
    event: "change",
  },
  props: {
    formData: Object,
  },
  components: {
    FormDisplay,
    FormDisplayList,
    FormUploader,
    FormUploaderFile,
    FormCheckboxGroup,
    FormProductSaleCount,
  },
  watch: {},

  data() {
    return {
      loginEmial: [],
    };
  },
  methods: {
    getEmial() {
      this.ccRequest
        .do(
          "admin/merchant/queryEmailListOfMerchant",
          { merchantNum: this.formData.merchantNum },
          "GET"
        )
        .then((res) => {
          this.loginEmial = res;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    this.getEmial();
  },
};
</script>
<style scoped lang="scss">
.input {
  width: 200px;
}
.banner {
  width: 200px;
}
.location {
  margin-bottom: 20px;
  display: flex;
  width: 500px;
  .title {
    width: 100px;
  }
  .value {
    margin-left: 10px;
    width: 300px;
  }
}

.main {
  max-width: 1000px;
}
</style>
